import { useEffect, useState } from "react";
import { isNullOrEmpty } from "../helpers/ObjectHelpers";
import { ShipDuotoneIcon } from "./icons/Icons";
import { SvgIcon } from "@progress/kendo-react-common";
import { hideOnImageError } from "../helpers/ElementHelpers";
import Spacer from "./Spacer";


const ShipImage = ({
    imoNo = null,
    description = "",
    canShowDummyImage = true,
    dummyImageSize = 64
}) => {

    const [showDummyImage, setShowDummyImage] = useState(false);

    useEffect(() => {
        setShowDummyImage(false);
    }, [imoNo])

    if (isNullOrEmpty(imoNo)) return;
    if (imoNo <= 0) return;

    return (                                                                                                                                                                                                                                                                                                                                                                    
        <>
            <div className="google-map-info-window-ship">
                {
                    !showDummyImage &&
                    <img
                        src={`https://www.ship-info.com/vessels/${imoNo}.jpg`}
                        alt={description}
                        style={{
                            width: "100%"
                        }}
                        onError={({ currentTarget }) => {
                            if (!canShowDummyImage) {
                                hideOnImageError(currentTarget);
                            } else {
                                setShowDummyImage(true);
                            }
                        }}
                    />
                }
                {(canShowDummyImage && showDummyImage) && (
                    <center>
                        <SvgIcon icon={ShipDuotoneIcon} style={{ height: dummyImageSize, width: dummyImageSize }} />
                    </center>
                )}
            </div>
            <Spacer height={15} />
        </>
    )
}

export default ShipImage;
